import { apiClient } from "@/api/apiClient";

export const fetchPropertyManagementByIdAsync = (id: number) =>
  apiClient().get(`/propertymanagements/${id}`);
